var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2495_4969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 50,
    height: 50,
    transform: "rotate(180 50 50)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2495_4969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0443 8.64779V18.752C11.0443 20.1756 11.5304 21.3735 12.5026 22.3457C13.4748 23.3179 14.6727 23.804 16.0964 23.804L33.0755 23.804L26.7734 17.502L31.3568 12.9186L45.5234 27.0853L31.3568 41.252L26.7734 36.6686L33.0755 30.3665L16.0964 30.3665C12.9019 30.3665 10.1675 29.2294 7.89323 26.9551C5.61892 24.6808 4.48177 21.9464 4.48177 18.752V8.64779H11.0443Z",
    fill: "#5144B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.12a2cb20c0f646bb289a4713d8340403.svg";
export { ForwardRef as ReactComponent };